import React from "react";
import "./index.scss";
const AuthLayout = (props) => {
    const [showPassword, setShowPassword] = React.useState(true);
    return (
        <section className="bg-user">
            <div className="d-flex justify-content-center icon-top">
                <div>
                    <img src="/icon/bottom.svg" alt="" className="img-l"/>
                </div>
            </div>
            <div className="container">

                <div className="row justify-content-center">

                    <div
                        className="col-xl-5 col-lg-5 col-md-6 ngon"
                        style={{ marginTop: 10 }}
                    >
                        <div
                            className="card o-hidden border-0 shadow-lg my-5"
                            style={{ borderRadius: 20 }}
                        >
                            <div className="card-body p-0">
                                {props.children}
                            </div>
                        </div>
                    </div>
                </div>

            </div>
            <div className="d-flex justify-content-center bottom-login align-items-end ">
                <div>
                    <img src="/icon/img-text-bottom.svg" alt="" className="img-n"/>
                    <p style={{ color: 'white' }} className="ga">© Copyright 2013 - 2022 Saijin Creative Agency</p>
                </div>
            </div>
        </section>
    );
};
export default AuthLayout;
